/**
 * 견적 관련 API 서비스 통합 export
 */

// 견적 요청 관련
export {
  createEstimateRequest,
  createEstimateRequestWithCredit,
  bulkCreateEstimateRequests,
  bulkCreateEstimateRequestsWithSpec,
  respondEstimateRequest,
  cancelEstimateRequest,
  getClientEstimateRequests,
  getClientEstimateRequestsStats,
  getFreelancerEstimateRequests,
  type EstimateRequestSortBy,
} from './estimate-requests.service'

// 견적서 관련
export {
  upsertEstimateDraft,
  submitEstimate,
  decideEstimate,
  getClientEstimates,
  getFreelancerEstimates,
  getFreelancerEstimateDetail,
  getClientEstimateDetail,
} from './estimates.service'

// 타입 export
export type {
  EstimateRequestRow,
  EstimateRow,
  CreateEstimateRequestParams,
  BulkCreateEstimateRequestsParams,
  BulkCreateEstimateRequestsWithSpecParams,
  EstimateRequestSpec,
  BulkCreateResult,
  RespondEstimateRequestParams,
  CancelEstimateRequestParams,
  UpsertEstimateDraftParams,
  SubmitEstimateParams,
  DecideEstimateParams,
  EstimateTargetType,
  EstimateRequestStatus,
  EstimateProposerType,
  EstimateStatus,
  ClientEstimateDetailResponse,
  ProposerInfo,
  EstimateRequestInfo,
  CounselSummary,
  MilestoneRow,
  MilestoneStatus,
} from '@/types/estimate'
